module.exports = __webpack_public_path__ + "static/media/nondata_large.666cd36b.png";